import { useEffect } from 'react';
import {
  useGetDRugNamesQuery,
  useGetIpReleaseDataQuery,
  useGetIpSupplyDetailsDataQuery,
  useGetIpSupplyOrderDataQuery,
  useLazyCreateIpReleaseQuery,
  useLazyCreateIpSupplyOrderQuery,
  useLazyUpdateIpReleaseQuery,
  useUpdateIpSupplyOrderMutation,
  useLazyIpSupplySendMailQuery,
  useLazyApproveSubmitQuery,
  useLazyGetIpSupplyOrderDataQuery,
  useGetAllReSupplyMutation,
  useSelectIpRerupplyOrderMutation,
  useUpdateIpResupplyOrderMutation,
  useLazyDownloadCSVQuery,
  useGetAllResupplyConfirmMutation,
  useLazyGetIpReleaseDataQuery
} from 'src/services/IPmanagement';
import { useLazyGetSiteStudyPersonnelDataQuery } from 'src/services/SiteContactInfo';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { updateUserAccess } from 'src/util/util';
// import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
// import { archLevel } from 'src/data/config';

export const useIPManagement = () => {
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const country = useAppSelector(state => state.site.selectedCountry);
  const siteId = useAppSelector(state => state.site.selectedSite);
  // const application = archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP;
  const application = process.env.REACT_APP_NAME;
  // const { selectedApp } = useSelectedAppInfo();
  // const application_section = selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG ? 'CONDUCT' : 'STARTUP';
  const dispatch = useAppDispatch();

  const {
    isLoading: getIpReleaseLoading,
    isError: getIpReleaseIsError,
    data: ipReleaseQueryData,
    error: getIpReleaseError,
    refetch: getIpReleaseQueryData
  } = useGetIpReleaseDataQuery({
    site_id: siteId,
    study_id: studyId,
    country,
    application
  });

  const [
    createIpRelease,
    {
      isLoading: createIpReleaseLoading,
      isError: createIpReleaseIsError,
      isSuccess: createIpReleaseIsSuccess,
      data: createIpReleaseData,
      error: createIpReleaseError
    }
  ] = useLazyCreateIpReleaseQuery();

  const [
    updateIpRelease,
    {
      isLoading: updateIpReleaseLoading,
      isError: updateIpReleaseIsError,
      isSuccess: updateIpReleaseIsSuccess,
      data: updateIpReleaseData,
      error: updateIpReleaseError
    }
  ] = useLazyUpdateIpReleaseQuery();
  const [
    getLazyIpReleaseQueryData,
    {
      isLoading: getLazyIpReleaseQueryDataLoading,
      isError: getLazyIpReleaseQueryDataIsError,
      isSuccess: getLazyIpReleaseQueryDataIsSuccess,
      data: LazyIpReleaseQueryData,
      error: getLazyIpReleaseQueryDataError
    }
  ] = useLazyGetIpReleaseDataQuery();

  const [
    getStudySitePersonnelQueryData,
    {
      isLoading: getStudySitePersonnelLoading,
      isError: getStudySitePersonnelIsError,
      isSuccess: getStudySitePersonnelIsSuccess,
      data: studySitePersonnelQueryData,
      error: getStudySitePersonnelError
    }
  ] = useLazyGetSiteStudyPersonnelDataQuery();

  const [
    getLazyIpSupplyOrderQueryData,
    {
      isLoading: getLazyIpSupplyOrderQueryDataLoading,
      isError: getLazyIpSupplyOrderQueryDataIsError,
      isSuccess: getLazyIpSupplyOrderQueryDataIsSuccess,
      data: lazyIpSupplyOrderQueryData,
      error: getLazyIpSupplyOrderQueryDataError
    }
  ] = useLazyGetIpSupplyOrderDataQuery();

  const {
    isLoading: getIpSupplyDetailsLoading,
    isError: getIpSupplyDetailsIsError,
    isSuccess: getIpSupplyDetailsIsSuccess,
    data: ipSupplyDetailsQueryData,
    error: getIpSupplyDetailsError,
    refetch: getIpSupplyDetailsQueryData
  } = useGetIpSupplyDetailsDataQuery({
    site_id: siteId,
    study_id: studyId,
    country,
    application
  });

  const {
    isLoading: getIpSupplyOrderLoading,
    isError: getIpSupplyOrderIsError,
    data: ipSupplyOrderQueryData,
    error: getIpSupplyOrderError,
    isSuccess: getIpSupplyOrderSucess,
    refetch: getIpSupplyOrderQueryData
  } = useGetIpSupplyOrderDataQuery({
    site_id: siteId,
    study_id: studyId,
    country,
    application
    // application_section
  });

  const [
    updateIpSupplyOrder,
    {
      isLoading: updateIpSupplyOrderLoading,
      isError: updateIpSupplyOrderIsError,
      data: updateIpSupplyOrderData,
      error: updateIpSupplyOrderError,
      isSuccess: updateIpSupplyOrderSuccess
    }
  ] = useUpdateIpSupplyOrderMutation();

  const [
    getIpSupplySendMailDataQueryData,
    {
      isLoading: getIpSupplySendMailDataLoading,
      isError: getIpSupplySendMailDataIsError,
      data: ipSupplySendMailData,
      error: getIpSupplySendMailDataError,
      isSuccess: getIpSupplySendMailDataSucess
    }
  ] = useLazyIpSupplySendMailQuery();

  const [
    downloadIPSuplyCSV,
    {
      isLoading: getdownloadCSVLoading,
      isError: getdownloadCSVIsError,
      data: downloadCSVData,
      isSuccess: getdownloadCSVIsSuccess,
      error: getdownloadCSVError
    }
  ] = useLazyDownloadCSVQuery();

  const {
    isLoading: getDrugNameDetailsLoading,
    isError: getDrugNameDetailsIsError,
    data: drugNameDetailsQueryData,
    error: getDrugNameDetailsError,
    refetch: getDrugNameDetailsQueryData
  } = useGetDRugNamesQuery({
    site_id: siteId,
    study_id: studyId,
    country,
    application
  });

  const [
    createIpSupplyOrder,
    {
      isLoading: createIpSupplyOrderLoading,
      isError: createIpSupplyOrderIsError,
      error: createIpSupplyOrderError,
      isSuccess: createIpSupplyOrderIsSuccess
    }
  ] = useLazyCreateIpSupplyOrderQuery();

  useEffect(() => {
    if (
      getIpSupplyDetailsError ||
      updateIpReleaseError ||
      getIpReleaseError ||
      createIpReleaseError ||
      getStudySitePersonnelError ||
      getIpSupplyOrderError ||
      updateIpSupplyOrderError ||
      createIpSupplyOrderError
    ) {
      updateUserAccess(
        getIpSupplyDetailsError ||
          updateIpReleaseError ||
          getIpReleaseError ||
          createIpReleaseError ||
          getStudySitePersonnelError ||
          getIpSupplyOrderError ||
          updateIpSupplyOrderError ||
          createIpSupplyOrderError,
        dispatch
      );
    }
  }, [
    getIpSupplyDetailsError,
    updateIpReleaseError,
    getIpReleaseError,
    createIpReleaseError,
    getStudySitePersonnelError,
    getIpSupplyOrderError,
    updateIpSupplyOrderError,
    createIpSupplyOrderError
  ]);

  const [
    approveSubmitIPSuply,
    {
      isLoading: approveSubmitLoading,
      isError: approveSubmitIsError,
      data: approveSubmitData,
      isSuccess: approveSubmitIsSuccess,
      error: approveSubmitCSVError
    }
  ] = useLazyApproveSubmitQuery();

  const [
    getAllIpResupply,
    {
      isLoading: ipResupplyIsLoading,
      isError: ipResupplyIsError,
      data: ipResupplyData,
      isSuccess: ipResupplyIsSuccess,
      error: ipResupplyError
    }
  ] = useGetAllReSupplyMutation();

  const [
    selectIpResupply,
    {
      isLoading: selectIpResupplyIsLoading,
      isError: selectIpResupplyIsError,
      data: selectIpResupplyData,
      isSuccess: selectIpResupplyIsSuccess,
      error: selectIpResupplyError
    }
  ] = useSelectIpRerupplyOrderMutation();

  const [
    updateIpResupplyOrder,
    {
      isLoading: updateIpResupplyOrderLoading,
      isError: updateIpResupplyOrderIsError,
      data: updateIpResupplyOrderData,
      error: updateIpResupplyOrderError,
      isSuccess: updateIpResupplyOrderSuccess
    }
  ] = useUpdateIpResupplyOrderMutation();
  const [
    getAllIpResupplySponsor,
    {
      isLoading: ipResupplySponsorIsLoading,
      isError: ipResupplySponsorIsError,
      data: ipResupplySponsorData,
      isSuccess: ipResupplySponsorIsSuccess,
      error: ipResupplySponsorError
    }
  ] = useGetAllResupplyConfirmMutation();

  return {
    ipReleaseQueryData,
    getIpReleaseError,
    getIpReleaseQueryData,
    getLazyIpReleaseQueryData,
    getLazyIpReleaseQueryDataLoading,
    getLazyIpReleaseQueryDataIsSuccess,
    getLazyIpReleaseQueryDataIsError,
    LazyIpReleaseQueryData,
    getLazyIpReleaseQueryDataError,
    updateIpRelease,
    updateIpReleaseData,
    createIpRelease,
    createIpReleaseData,
    createIpReleaseError,
    createIpReleaseIsSuccess,
    studySitePersonnelQueryData,
    getStudySitePersonnelQueryData,
    getIpSupplyDetailsQueryData,
    ipSupplyDetailsQueryData,
    getIpSupplyOrderQueryData,
    getIpSupplyOrderIsError,
    ipSupplyOrderQueryData,
    getIpSupplyOrderError,
    updateIpSupplyOrder,
    updateIpSupplyOrderError,
    updateIpSupplyOrderSuccess,
    updateIpSupplyOrderIsError,
    createIpSupplyOrder,
    createIpSupplyOrderError,
    createIpSupplyOrderIsSuccess,
    createIpSupplyOrderIsError,
    createIpReleaseLoading,
    createIpReleaseIsError,
    getDrugNameDetailsLoading,
    getDrugNameDetailsIsError,
    drugNameDetailsQueryData,
    getDrugNameDetailsError,
    getDrugNameDetailsQueryData,
    getIpReleaseLoading,
    getIpReleaseIsError,
    updateIpReleaseLoading,
    updateIpReleaseIsError,
    updateIpReleaseIsSuccess,
    getStudySitePersonnelLoading,
    getStudySitePersonnelIsError,
    getStudySitePersonnelIsSuccess,
    getIpSupplyDetailsLoading,
    getIpSupplyDetailsIsError,
    getIpSupplyDetailsIsSuccess,
    getIpSupplyOrderLoading,
    getIpSupplyOrderSucess,
    updateIpSupplyOrderLoading,
    updateIpSupplyOrderData,
    createIpSupplyOrderLoading,
    getIpSupplySendMailDataLoading,
    getIpSupplySendMailDataIsError,
    ipSupplySendMailData,
    getIpSupplySendMailDataError,
    getIpSupplySendMailDataSucess,
    getIpSupplySendMailDataQueryData,
    downloadIPSuplyCSV,
    downloadCSVData,
    getdownloadCSVLoading,
    getdownloadCSVIsError,
    getdownloadCSVIsSuccess,
    getdownloadCSVError,
    approveSubmitIPSuply,
    approveSubmitLoading,
    approveSubmitIsError,
    approveSubmitData,
    approveSubmitIsSuccess,
    approveSubmitCSVError,
    getLazyIpSupplyOrderQueryData,
    getLazyIpSupplyOrderQueryDataLoading,
    getLazyIpSupplyOrderQueryDataIsError,
    getLazyIpSupplyOrderQueryDataIsSuccess,
    lazyIpSupplyOrderQueryData,
    getLazyIpSupplyOrderQueryDataError,
    getAllIpResupply,
    ipResupplyIsLoading,
    ipResupplyIsError,
    ipResupplyData,
    ipResupplyIsSuccess,
    ipResupplyError,
    selectIpResupply,
    selectIpResupplyIsLoading,
    selectIpResupplyIsError,
    selectIpResupplyData,
    selectIpResupplyIsSuccess,
    selectIpResupplyError,
    updateIpResupplyOrder,
    updateIpResupplyOrderLoading,
    updateIpResupplyOrderIsError,
    updateIpResupplyOrderData,
    updateIpResupplyOrderError,
    updateIpResupplyOrderSuccess,
    getAllIpResupplySponsor,
    ipResupplySponsorIsLoading,
    ipResupplySponsorIsError,
    ipResupplySponsorData,
    ipResupplySponsorIsSuccess,
    ipResupplySponsorError
  };
};
